var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('ul',[_c('div',{staticClass:"text-h6 my-4"},[_vm._v("Log")]),_vm._l((_vm.logs),function(log){return _c('li',{key:log.id,staticClass:"mb-2"},[_vm._v("\n            "+_vm._s(log.message)+"\n        ")])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }